export const ModalChangeNicknameTranslationsUk = {
  changeNickname: 'Змінити псевдонім',
  Nickname: 'Псевдонім',
  saveButton: 'Зберегти',
};
